import {
  Component, ContentChild,
  Injector,
  Optional, TemplateRef
} from '@angular/core';
import {CommonModule} from "@angular/common";

import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, styler, register } from "@wm/components-base";
import { WmsTranscludeDirective } from '../../page/wms-transclude/wms-transclude.directive';
import { runtimeEventManager, setCSS } from '@wm/core';

const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-logindialog',
  displayType: DISPLAY_TYPE.INLINE_BLOCK
};

@Component({
  selector: '[wmLoginDialog]',
  template: `<div init-widget class="app-view dialog-view clearfix" wm-navigable-element="true">
    <div class="app-dialog modal-dialog app-login-dialog" [ngStyle]="{width: width}" *ngIf="loadDialogContent">
      <div class="modal-content">
        <div class="app-dialog-header modal-header">
          <button aria-label="Close" class="app-dialog-close close" [ngClass]="{'btn-text': isPrism}" title="Close">
            <span class="app-icon wi wi-clear" aria-hidden="true"></span>
          </button>
          <!-- Change the header tag based on the heading level -->
          <ng-container [ngSwitch]="headinglevel">
            <ng-container *ngSwitchCase="'h1'">
              <h1 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h1>
            </ng-container>
            <ng-container *ngSwitchCase="'h2'">
              <h2 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h2>
            </ng-container>
            <ng-container *ngSwitchCase="'h3'">
              <h3 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h3>
            </ng-container>
            <ng-container *ngSwitchCase="'h4'">
              <h4 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h4>
            </ng-container>
            <ng-container *ngSwitchCase="'h5'">
              <h5 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h5>
            </ng-container>
            <ng-container *ngSwitchCase="'h6'">
              <h6 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h6>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <h4 class="app-dialog-title modal-title">
                <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
              </h4>
            </ng-container>
          </ng-container>
          <ng-template #headerTemplate>
            <i [ngClass]="iconclass" [ngStyle]="{width: iconwidth, height: iconheight, margin: iconmargin}"  *ngIf="iconclass && !iconurl"></i>
            <img data-identifier="img" [src]="iconurl" *ngIf="iconurl" [ngStyle]="{width:iconwidth, height:iconheight, margin:iconmargin}"/>
            <span class="dialog-heading" [textContent]="title" [id]="titleId"></span>
          </ng-template>
        </div>
        <div class="app-dialog-body modal-body" wmsTransclude>
          <ng-content></ng-content>
        </div>
        <ng-container *ngTemplateOutlet="dialogFooter"></ng-container>
      </div>
    </div>
</div>
`,
  providers: [
    provideAsWidgetRef(LoginDialogComponent)
  ],
  exportAs: 'wmLoginDialog',
  standalone: true,
  imports: [ CommonModule, WmsTranscludeDirective ],
  styles: []
})
export class LoginDialogComponent extends StylableComponent {
  static initializeProps = register('wm-logindialog');
  override width:string;
  iconurl: string;
  iconclass: string;
  title: string;
  iconmargin: string;
  iconheight: string;
  iconwidth: string;
  titleId: string;
  loadDialogContent: boolean = false;
  headinglevel: string = 'h4';
  isPrism: boolean;
  @ContentChild('dialogFooter', {read: TemplateRef}) dialogFooter: TemplateRef<any>;
  constructor(inj: Injector,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
    const projectService = runtimeEventManager.getService('projectService');
    this.isPrism = projectService.isPrism();
     this.registerPropertyChangeListener((key: string, nv: any, ov?: any) => {
      if (key === "width") {
        setCSS(this.nativeElement as HTMLElement, key, '100%');
      }
    })
  }
  override ngOnInit() {
    super.ngOnInit();
    if(this.getAttr('title.bind')) {
      this.title='bind:'+this.getAttr('title.bind');
    }
  }
  override get stylerEl(): HTMLElement | null {
    return this.nativeElement.querySelector('.modal-dialog');
  }

  override onStyleChange(key: string, nv: any, ov?: any) {
    if (key === 'height' && nv !== ov) {
      this.$element.find('.modal-body').css('height', nv);
    }
  }
}

